import { LOADING } from "../action/action-types";

export default function loading(state = true, action){
    switch(action.type){
        case LOADING:
            return state = action.payload
        default:
            return state
    }
}